import React from 'react'

import './styles.css'

// define um card grande para ser usado em um produto
const LargeCardFake = ({ id }) => {
    return (
        <div key={id} className="large-card-fake-container" />
    );
}

export default LargeCardFake;